module.exports = __webpack_public_path__ + "img/box9-16.485a66db.png";